import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.links');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-links',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.links/view.scss */
:host {
  display: block;
  width: 100%;
  min-height: 100vh;
  background: #0f172a;
}`],
})
export class PageLinksComponent implements OnInit {
    public links: any[] = [
        { url: 'https://solution.inspectpro.seasonai.net/main', icon: 'fa-solid fa-helmet-safety', label: 'M-Pro', color: 'bg-blue-500', desc1: 'Main Project Hub', desc2: '데이터 통합 관리' },
        { url: 'https://portal.isri.co.kr/dashboard', icon: 'fa-solid fa-building-shield', label: 'F-Pro', color: 'bg-emerald-500', desc1: '비대면 결재/운영 자동화', desc2: '스마트 오피스 관리' },
        { url: 'https://safety.inspectpro.seasonai.net/home', icon: 'fa-solid fa-magnifying-glass-chart', label: 'Inspect-Pro', color: 'bg-orange-500', desc1: '현장조사 AI 인식', desc2: '도면/손상표 자동화' },
        { url: 'https://safety.inspectpro.seasonai.net/checklist', icon: 'fa-solid fa-clipboard-check', label: 'CL-Pro', color: 'bg-violet-500', desc1: '체크리스트 디지털전환', desc2: '이상 항목 자동플래그' },
        { url: 'https://check.inspect.seasonai.net/chatbot', icon: 'fa-solid fa-robot', label: 'AutoCheck-Pro', color: 'bg-rose-500', desc1: '보고서 품질 자동평가', desc2: '유사도/오탈자 검증' },
        { url: 'http://pq.isri.co.kr', icon: 'fa-solid fa-chart-column', label: 'NicePQ-Pro', color: 'bg-cyan-500', desc1: 'PQ 입찰 문서 자동분석', desc2: '최적 기술자조합 산출' },
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public open(url: string) {
        window.open(url, '_blank', 'noopener,noreferrer');
    }
}

export default PageLinksComponent;